var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfilePicturePlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9414_31634)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    rx: 42.5,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 32.5,
    r: 14.5,
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.5,
    cy: 74.5,
    rx: 31.5,
    ry: 21.5,
    fill: "#C7C7C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9414_31634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    rx: 42.5,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicturePlaceholder);
export default __webpack_public_path__ + "static/media/profile-picture-placeholder.bc23f1af584c480e4b1ab30255eb1434.svg";
export { ForwardRef as ReactComponent };